module.exports = __webpack_public_path__ + "img/past-events_breeders-cup.ca5aa99f.jpg";